export default __webpack_public_path__ + "static/media/3f.abc510cf.png";